export default __webpack_public_path__ + "static/media/bag-float.62ed6383.png";